<template>
  <div class="row py-5">
    <div class="col">
      <div class="text-center no-results">
        <div class="fa fa-search"></div>
        {{ text }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      header_text: this.text
    };
  },
  props: ['text']
};
</script>
<style scoped>
.no-results .fa {
  display: block;
  margin-bottom: 20px;
  font-size: 8rem;
  opacity: .4;
}
.no-results {
  font-size: 1.3rem;
}
</style>
